export enum LangEnum {
    EN = 'en',
    FR = "fr",
    DE = "de",
    ES = "es"
}
